<cx-global-message aria-atomic="true" aria-live="assertive" class="productMsg"></cx-global-message>

<ng-container *ngIf="productApiResult ? productApiResult : (product$ | async) as product">
  <div class="app-product-card-information">
    <div class="product-title">
      {{ productApiResult?.name }}
    </div>
    <div class="product-desc">
      {{ productApiResult?.summary }}
    </div>
    <div class="product-spec" *ngIf="productApiResult?.ean">
      {{ "productcardinformation.eanNum" | cxTranslate }}
      {{ productApiResult?.ean }}
    </div>
    <div class="product-spec" *ngIf="
        productApiResult?.casesPerLayer !== '0' ||
        productApiResult?.casesPerPallet !== '0'
      ">
      {{ "productcardinformation.casesPerLayer" | cxTranslate }}
      {{ productApiResult?.casesPerLayer }}
      /
      <span>{{ "productcardinformation.casesPerPallet" | cxTranslate }}
        {{ productApiResult?.casesPerPallet }}</span>
    </div>
    <div class="product-spec" *ngIf="
        productApiResult?.grossWeight !== '0' ||
        productApiResult?.volume !== '0'
      ">
      {{ "productcardinformation.weightPerCase" | cxTranslate }}
      {{ productApiResult?.grossWeight }}
      {{ productApiResult?.weightUnit }}
      /
      <span>{{ "productcardinformation.volPerCases" | cxTranslate }}
        {{ productApiResult?.volume }} {{ productApiResult?.volumeUnit }}</span>
    </div>
    <div class="product-spec" *ngIf="
        productApiResult?.length !== '0' || productApiResult?.width !== '0'
      ">
      <span>{{ "productcardinformation.lengthPerCases" | cxTranslate }}
        {{ productApiResult?.length }} {{ productApiResult?.dimensionalUnit }} /
        {{ "productcardinformation.widthPerCases" | cxTranslate }}
        {{ productApiResult?.width }}
        {{ productApiResult?.dimensionalUnit }}</span>
    </div>
  </div>
</ng-container>